var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThematicSimilarity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1C4D5E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0010147,2 C14.0927599,3.21047734 15.5,5.47236816 15.5,8.06293752 C15.5,10.6535069 14.0927599,12.9153977 12.0010147,14.125875 C9.90763242,12.9160283 8.5,10.653868 8.5,8.06293752 C8.5,5.50992312 9.86673488,3.27612674 11.9084482,2.05330481 L12.0010147,2 Z M8.68122745,8.58205248 L13.498517,3.76476294 M9.2972735,10.9660064 L14.70139,5.56188997 M10.4825147,12.8052417 L15.3419124,7.94584391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.5 C14.634207,0.5 13.3536098,0.864916567 11.7507242,1.5036895 C10.6474352,0.865224382 9.36635521,0.5 8,0.5 C5.92893219,0.5 4.05393219,1.33946609 2.69669914,2.69669914 C1.33946609,4.05393219 0.5,5.92893219 0.5,8 C0.5,10.0710678 1.33946609,11.9460678 2.69669914,13.3033009 C4.05393219,14.6605339 5.92893219,15.5 8,15.5 C9.36630099,15.5 10.6473408,15.1348186 12.250213,14.4968528 C13.3532903,15.1349825 14.6340316,15.5 16,15.5 C18.0710678,15.5 19.9460678,14.6605339 21.3033009,13.3033009 C22.6605339,11.9460678 23.5,10.0710678 23.5,8 C23.5,5.92893219 22.6605339,4.05393219 21.3033009,2.69669914 C19.9460678,1.33946609 18.0710678,0.5 16,0.5 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThematicSimilarity);
export default __webpack_public_path__ + "static/media/thematicSimilarity.9b34cead45b7d8fe768d2e7c26a0374d.svg";
export { ForwardRef as ReactComponent };